import * as React from 'react';
import * as Loaders from 'react-spinners';
import CenterFramed from '../components/CenteredFrame';

export default class  LoadingFrame extends React.Component<any> {
    render() {
        switch (this.props.type) {
            case 'bar':
                return (
                    <CenterFramed {...this.props} width="100px" height="5px">
                        <Loaders.BarLoader color="teal" height={5} width={100}/>
                    </CenterFramed>
                );
            case 'ring':
                return (
                    <CenterFramed {...this.props} width="60px" height="60px">
                        <Loaders.RingLoader color="teal" size={60}/>
                    </CenterFramed>
                );
            case 'grid':
                return (
                    <CenterFramed {...this.props} width="52px" height="52px">
                        <Loaders.GridLoader color="teal" size={10} {...{margin: '2px'}}/>
                    </CenterFramed>
                );
            case 'pac':
                return (
                    <CenterFramed {...this.props} width="112px" height="52px">
                        <Loaders.PacmanLoader color="teal" size={25} margin="2px"/>
                    </CenterFramed>
                );

            case 'beat':
                return (
                    <CenterFramed {...this.props} width="112px" height="52px">
                        <Loaders.BeatLoader color="teal" size={15} margin="5px"/>
                    </CenterFramed>
                );

            default: 
                return (
                    <CenterFramed {...this.props} width="112px" height="52px">
                        <Loaders.SyncLoader	 color="teal" size={15} margin="5px"/>
                    </CenterFramed>
                );
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/LoadingFrame.tsx